import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'shared.sections.meet.title',
		defaultMessage: 'Meet Calm',
		description: 'Section title that says Meet Calm',
	},
	subtitle1: {
		id: 'shared.sections.meet.subtitle1',
		defaultMessage: 'Meditate',
		description: 'Heading for Meditate blurb',
	},
	message1: {
		id: 'shared.sections.meet.message1',
		defaultMessage: 'Learn the life-changing skill of meditation',
		description: 'Blurb about learning the life-changing skill of meditation',
	},
	subtitle2: {
		id: 'shared.sections.meet.subtitle2',
		defaultMessage: 'Sleep',
		description: 'Heading for Sleep blurb',
	},
	message2: {
		id: 'shared.sections.meet.message2',
		defaultMessage: 'Get more restful sleep and wake up feeling refreshed',
		description: 'Blurb about getting more restful sleep and waking up feeling refreshed',
	},
	subtitle3: {
		id: 'shared.sections.meet.subtitle3',
		defaultMessage: 'Body',
		description: 'Heading for Body blurb',
	},
	message3: {
		id: 'shared.sections.meet.message3',
		defaultMessage: 'Video lessons on mindful movement and gentle stretching',
		description: 'Blurb about video lessons on mindful movement and gentle stretching',
	},
	subtitle4: {
		id: 'shared.sections.meet.subtitle4',
		defaultMessage: 'Music',
		description: 'Heading for Music blurb',
	},
	message4: {
		id: 'shared.sections.meet.message4',
		defaultMessage: 'Exclusive music to help you focus, relax, and sleep',
		description: 'Blurb about access to exclusive music to help you focus, relax, and sleep',
	},
});
